module.exports = require("cloudinary-core");


//////////////////
// WEBPACK FOOTER
// external "cloudinary-core"
// module id = 172
// module chunks = 0